import React from 'react';
import errorIcon from  '../../assets/images/icons/error-icon.png';
import tickIcon from '../../assets/images/icons/tick-icon.png';

const AlertModal = ({ isOpen, onClose, title, message, error = false, showConfirmButton = false, onConfirm, confirmLabel = 'Confirm', size = '' }) => {
    if (!isOpen) return null;

    return (
        <div className="modal fade show" tabIndex="-1" aria-labelledby="alertModal" style={{ display: 'block' }}>
            <div className={`modal-dialog modal-dialog-centered alert-modal ${size ? `modal-${size}` : ''}`}>
                <div className="modal-content alert-popup">
                    <div className="modal-body  text-center"> 
                        {error ? (
                            <img src={errorIcon} className='mb-3' width={50}  />
                        ) : (
                            <img src={tickIcon} className='mb-3' width={50}  />
                        )}
                        <h4>{title}</h4>
                        {message != null && <div className="mt-2">{typeof message === 'string' ? <p>{message}</p> : message}</div>}
                        <div className="mt-3 d-flex gap-2 justify-content-center flex-wrap">
                            {showConfirmButton && onConfirm ? (
                                <>
                                    <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Cancel</button>
                                    <button type="button" className="btn blue-btn close-btn" onClick={onConfirm}>{confirmLabel}</button>
                                </>
                            ) : (
                                <button type="button" className="btn blue-btn close-btn" onClick={onClose}>OK</button>
                            )}
                        </div>
                    </div>               
                </div>
            </div>
        </div>
    );
};

export default AlertModal;
